import { render, staticRenderFns } from "./rgznHome.vue?vue&type=template&id=64874236&scoped=true"
import script from "./rgznHome.vue?vue&type=script&lang=js"
export * from "./rgznHome.vue?vue&type=script&lang=js"
import style0 from "./rgznHome.vue?vue&type=style&index=0&id=64874236&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64874236",
  null
  
)

export default component.exports